import { render } from "./SettingsItem.vue?vue&type=template&id=e581064c"
import script from "./SettingsItem.vue?vue&type=script&lang=js"
export * from "./SettingsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__